const getters = {
  username: state => state.user.info.username
}
export default getters
